import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=aff5ed82"
import script from "./permissions.vue?vue&type=script&lang=ts"
export * from "./permissions.vue?vue&type=script&lang=ts"
import style0 from "./permissions.vue?vue&type=style&index=0&id=aff5ed82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports